import React from 'react';
import { FormikProps } from 'formik';
import { Grid, styled, TextField } from '@mui/material';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import { IGenericFormValues } from 'src/pages/ManualLookup/utils';
import { capitalizedLowercase } from 'src/utils/string';
import { ErrorText } from 'src/style/common';

export interface SingleFormFieldProps {
  fieldName: string;
  formikProps: FormikProps<any>;
  initialPrefix: string;
  generalFormInitialValues: IGenericFormValues;
  setGeneralFormInitialValues: React.Dispatch<React.SetStateAction<IGenericFormValues>>;
}

const SingleFormField: React.FC<SingleFormFieldProps> = ({ fieldName, formikProps, initialPrefix, generalFormInitialValues, setGeneralFormInitialValues }) => {
  const listOfNonStandardsTextFieldProducts: string[] = ['phone', 'browser', 'domain'];

  const labelTranslator = (fieldName: string) => {
    switch (fieldName) {
      case 'user_agent':
        return 'Device';
      case 'ip':
        return 'IP Address';
      case 'email':
        return 'Email Address';
      case 'domain':
        return 'Domain';
      default:
        return capitalizedLowercase(fieldName);
    }
  };

  return (
    <Grid xs={12} item>
      {fieldName === 'phone' && (
        <PhoneInput
          dropdownStyle={{ position: 'fixed' }}
          country={initialPrefix.toLowerCase() || formikProps.getFieldProps('phone_prefix').value}
          enableSearch
          value={formikProps.getFieldProps('phone').value || generalFormInitialValues.phone}
          onChange={(phone, obj: CountryData) => {
            formikProps.setFieldTouched('phone_prefix');
            formikProps.validateField('phone_prefix');
            formikProps.setFieldTouched('phone');
            formikProps.validateField('phone');
            formikProps.setFieldValue('phone_prefix', obj.countryCode, true);
            formikProps.setFieldValue('phone', phone, true);
            setGeneralFormInitialValues({
              ...generalFormInitialValues,
              phone: phone,
            });
          }}
          inputStyle={{ width: '100%', height: 53 }}
          specialLabel="Phone Number"
          enableLongNumbers
        />
      )}
      {fieldName === 'domain' && formikProps.getFieldProps('domain.country').value && (
        <Grid container spacing={3}>
          <TallerGrid item xs={12} md={12}>
            <TextField fullWidth variant="outlined" label="Domain" {...formikProps.getFieldProps('domain.value')} />
          </TallerGrid>
          {formikProps.errors.domain && <ErrorText variant="body2">Domain is not valid.</ErrorText>}
        </Grid>
      )}
      {!listOfNonStandardsTextFieldProducts.includes(fieldName) && (
        <TextField style={{ width: '100%' }} variant="outlined" label={labelTranslator(fieldName)} {...formikProps.getFieldProps(fieldName)} />
      )}
    </Grid>
  );
};

export default SingleFormField;

const TallerGrid = styled(Grid)(() => ({
  '& input': {
    height: 23,
  },
}));
